// import React from "react";

// const VideoSlider = () => {
//   return (
//     <div className="container-fluid p-0">
//       <video
//         className="w-100"
//         autoPlay
//         muted
//         loop
//         playsInline
//         controls={false}
//         style={{
//           height: "500px",
//           objectFit: "cover",
//         }}
//       >
//         <source src="/images/slider/slider.mp4" type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// };

// export default VideoSlider;


// import React from "react";

// const VideoSlider = () => {
//   return (
//     <div
//       style={{
//         width: "100%",
//         backgroundColor: "#000",
//       }}
//     >
//       <video
//         autoPlay
//         muted
//         loop
//         playsInline
//         controls={false}
//         style={{
//           width: "100%",
//           height: "auto",
//           maxHeight: "100vh",
//           objectFit: "contain",
//           display: "block",
//         }}
//       >
//         <source src="/images/slider/slider.mp4" type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// };

// export default VideoSlider;



// import React, { useRef, useEffect } from "react";

// const VideoSlider = () => {
//   const videoRef = useRef(null);

//   useEffect(() => {
//     const playVideo = () => {
//       if (videoRef.current) {
//         videoRef.current.muted = false;
//         videoRef.current.play();
//       }
//       document.removeEventListener("click", playVideo);
//     };

//     document.addEventListener("click", playVideo);
//   }, []);

//   return (
//     <div className="video-slider">
//       <video
//         ref={videoRef}
//         autoPlay
//         muted
//         loop
//         playsInline
//         style={{ width: "100%" }}
//       >
//         <source src="/images/slider/slider.mp4" type="video/mp4" />
//       </video>
//     </div>
//   );
// };

// export default VideoSlider;


// import React, { useRef, useState, useEffect } from "react";

// const VideoSlider = () => {
//   const videoRef = useRef(null);
//   const [isMuted, setIsMuted] = useState(true);

//   useEffect(() => {
//     if (videoRef.current) {
//       videoRef.current.muted = isMuted;
//       videoRef.current.play().catch(() => {
//         // Ignore autoplay errors
//       });
//     }
//   }, [isMuted]);

//   const toggleSound = () => {
//     if (videoRef.current) {
//       const newMutedState = !isMuted;
//       videoRef.current.muted = newMutedState;
//       setIsMuted(newMutedState);

//       videoRef.current.play().catch(() => {
//         // Ignore play errors
//       });
//     }
//   };

//   return (
//     <div
//       className="video-slider"
//       style={{
//         position: "relative",
//         width: "100%",
//       }}
//     >
//       <video
//   ref={videoRef}
//   autoPlay
//   muted={isMuted}
//   loop
//   playsInline
//   style={{
//     width: "100%",
//     display: "block",
//   }}
// >
//   <source src="/images/slider/slider.mp4" type="video/mp4" />
//   Your browser does not support the video tag.
// </video>

//       {/* Sound Toggle Button */}
//       <button
//         onClick={toggleSound}
//         style={{
//           position: "absolute",
//           top: "20px",
//           right: "20px",
//           width: "45px",
//           height: "45px",
//           border: "none",
//           borderRadius: "50%",
//           background: "rgba(0, 0, 0, 0.6)",
//           color: "#fff",
//           fontSize: "20px",
//           cursor: "pointer",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           zIndex: 1000,
//           transition: "background 0.3s ease",
//         }}
//         onMouseEnter={(e) =>
//           (e.currentTarget.style.background = "rgba(0, 0, 0, 0.8)")
//         }
//         onMouseLeave={(e) =>
//           (e.currentTarget.style.background = "rgba(0, 0, 0, 0.6)")
//         }
//       >
//         {isMuted ? "🔇" : "🔊"}
//       </button>
//     </div>
//   );
// };

// export default VideoSlider;



import React, { useRef, useState, useEffect } from "react";

const VideoSlider = () => {
  const videoRef = useRef(null);

  // Sound is OFF by default
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
      videoRef.current.play().catch(() => {});
    }
  }, [isMuted]);

  const toggleSound = () => {
    if (videoRef.current) {
      const newMutedState = !isMuted;
      videoRef.current.muted = newMutedState;
      setIsMuted(newMutedState);

      videoRef.current.play().catch(() => {});
    }
  };

  return (
    <div
      className="video-slider"
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      <video
        ref={videoRef}
        autoPlay
        muted={isMuted}
        loop
        playsInline
        style={{
          width: "100%",
          display: "block",
        }}
      >
        <source src="/images/slider/slider.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Small Sound Toggle Button */}
 <button
  onClick={toggleSound}
  aria-label={isMuted ? "Unmute video" : "Mute video"}
  style={{
    position: "absolute",
    top: "12px",
    right: "12px",
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: "14px",
    cursor: "pointer",
    padding: "2px",
    margin: 0,
    outline: "none",
    boxShadow: "none",
    zIndex: 1000,
    WebkitTapHighlightColor: "transparent",
  }}
>
  {isMuted ? "🔈" : "🔊"}
</button>
    </div>
  );
};

export default VideoSlider;